// Telas presas a um processo (Painel, Ativos, Cestas e lotes, Etapas): o
// processo vem de ?processo= e muda pelo CompetitiveProcessPicker. A tela
// implementa onProcess(id), chamado quando o processo e definido ou trocado.
export default {
    data() {
        return { processId: Number(this.$route.query.processo) || null, process: null };
    },
    watch: {
        processId(id) {
            if (String(this.$route.query.processo || "") !== String(id || "")) {
                const query = { ...this.$route.query };
                if (id) query.processo = String(id);
                else delete query.processo;
                this.$router.replace({ query }).catch(() => {});
            }
            if (id && typeof this.onProcess === "function") this.onProcess(id);
        },
    },
    created() {
        if (this.processId && typeof this.onProcess === "function") this.onProcess(this.processId);
    },
};
